<template>
	<v-btn v-bind="$attrs" v-on="$listeners" class="secondary-button" :class="{ 'small-btn': smallBtn }">
		<slot />
	</v-btn>
</template>

<script>
export default {
	name: 'SecondaryButton',
	props: {
		smallBtn: { type: Boolean },
	},
};
</script>

<style scoped lang="scss">
.secondary-button {
	background-color: var(--primary-color) !important;
	color: white !important;
	text-transform: none !important;

	&:not(.small-btn) {
		height: 40px !important;
	}
}
</style>
